import styled from 'styled-components';
import { mediaMax } from '../Media Template/Media Template';

export const TrendingHolder = styled.div.attrs({
  className: 'TrendingHolder'
})`
  .Title {
    font-style: italic;
  }
  background: #2a2a2a;
  width: 100%;
  /* max-width: 1040px; */
  min-height: 60px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  ${mediaMax.desktop`flex-direction: column;`};
`;
